module.exports = __webpack_public_path__ + "static/img/jifen_1.920670aa.png";